'use client';

import { c as _c } from "react/compiler-runtime";
import { Card, ExternalLink } from '@morpho-org/ui-v6/server';
import { Button } from '@repo/ui';
import { ArrowDiagonalUp } from '@repo/ui/icons';
import { memo } from 'react';
import CredoraLogo from './CredoraLogo';
export interface VaultRatingsClientProps {
  rating: {
    provider: string;
    score: string;
  };
}
const CREDORA_RISK_SCORE_URL = 'https://docs.redstone.finance/docs/redstone-credora/how-to-rate-morpho/';
const VaultRatingsClient = t0 => {
  const $ = _c(6);
  const {
    rating
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-1.5"><span className="text-secondary-foreground text-xs">Risk Score</span><CredoraLogo className="text-secondary-foreground" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== rating.score) {
    t2 = <div className="gap-sm flex flex-col">{t1}<div className="gap-2xs flex items-center"><span className="text-md text-foreground">{rating.score}</span></div></div>;
    $[1] = rating.score;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="top-md right-md absolute"><ExternalLink href={CREDORA_RISK_SCORE_URL}><Button variant="secondary" size="iconSm" aria-label="Learn about the risk score"><ArrowDiagonalUp /></Button></ExternalLink></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Card className="relative w-fit min-w-[299px] max-md:min-w-full">{t2}{t3}</Card>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default memo(VaultRatingsClient);